var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"},attrs:{"id":"back-to-top"}},[_c('a',{staticClass:"top",attrs:{"id":"top","href":"javascript:void(0)"},on:{"click":function($event){return _vm.scrollTop()}}},[_c('i',{staticClass:"ion-chevron-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }